<template>
  <BasicPopup
    title="Оценка быстрых откликов"
    :visible="visible"
    @close="close"
  >
    <TransitionExpand mode="out-in">
      <SectionGroup
        v-if="!voted"
        gap="large"
      >
        <FormSection
          appearance="expert-profile"
          title="Как вам быстрые отклики?"
        >
          <RatingStarsForm
            color="yellow"
            :fixed="!!score"
            :value="score"
            @vote="score = $event"
          />
        </FormSection>
        <FormSection
          appearance="expert-profile"
          title="Что вам понравилось?"
        >
          <BasicTextarea v-model="liked" :max-length="500" />
        </FormSection>
        <FormSection
          appearance="expert-profile"
          title="Что не понравилось, было неудобно?"
        >
          <BasicTextarea v-model="disliked" :max-length="500" />
        </FormSection>
        <FormSection
          appearance="expert-profile"
          title="Что стоит доработать?"
        >
          <BasicTextarea v-model="improve" :max-length="500" />
        </FormSection>
      </SectionGroup>
      <NoContent
        v-else
        title="Спасибо, что уделили время!"
        :icon="$options.feedbackReceivedIcon"
      />
    </TransitionExpand>

    <template
      v-if="!voted"
      #footer
    >
      <BasicButton
        appearance="primary"
        size="l"
        :disabled="isLoading"
        @click="vote"
      >
        Отправить
      </BasicButton>
    </template>
  </BasicPopup>
</template>

<script>
  import { showErrorNotification } from 'src/services/api.js';
  import { QuickResponsesService } from 'src/services/quick-responses.js';
  import { bem } from 'src/utils/bem.js';

  import BasicButton from 'src/components/BasicButton/BasicButton.vue';
  import BasicTextarea from 'src/components/form/BasicTextarea/BasicTextarea.vue';
  import FormSection from 'src/components/form/FormSection/FormSection.vue';
  import NoContent from 'src/components/placeholders/NoContent/NoContent.vue';
  import BasicPopup from 'src/components/popup/BasicPopup/BasicPopup.vue';
  import RatingStarsForm from 'src/components/RatingStarsForm/RatingStarsForm.vue';
  import SectionGroup from 'src/components/sections/SectionGroup/SectionGroup.vue';
  import TransitionExpand from 'src/components/transitions/TransitionExpand/TransitionExpand.vue';

  import feedbackReceived from 'images/feedback_received.svg';

  const feedbackReceivedIcon = {
    src: feedbackReceived,
    width: '96px',
    height: '96px'
  };

  export default {
    name: 'QuickVacanciesFeedbackModal',
    components: { NoContent, RatingStarsForm, TransitionExpand, SectionGroup, BasicTextarea, FormSection, BasicButton, BasicPopup },
    feedbackReceivedIcon,
    props: {
      visible: Boolean,
    },
    emits: ['close'],
    data() {
      return {
        liked: '',
        disliked: '',
        improve: '',
        score: null,
        voted: false,
        isLoading: false,
      }
    },
    methods: {
      vote() {
        const form = this.buildForm();
        this.isLoading = true;

        QuickResponsesService.sendFeedback(form)
          .then(() => {
            this.voted = true;
          })
          .catch(showErrorNotification)
          .finally(() => {
            this.isLoading = false;
          });
      },
      close() {
        if (this.voted) {
          this.clearForm();
        }
        this.$emit('close', this.voted);
      },
      clearForm() {
        this.liked = '';
        this.disliked = '';
        this.improve = '';
        this.score = null;
      },
      buildForm() {
        const { score, liked, disliked, improve } = this;
        const form = {
          kind: 'rec_vacancies',
          score,
          liked,
          disliked,
          improve
        };

        return { form };
      },
      bem,
    },
    computed: {
      showLiked() {
        return this.score > 2;
      },
    },
  };
</script>
